import { mergeQueryKeys } from '@lukemorales/query-key-factory';
import { accountInfoFactory } from './accountInfo.factory';

export const accountEditQueries = mergeQueryKeys(accountInfoFactory);

export type AccountEditQueries = typeof accountEditQueries;
